import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";
import { formatDateLocal } from "@/shared/lib/date-time";

type QCResultTrendProps = {
  stats: QCResultStatsResult;
};

export function QCResultTrend({ stats }: QCResultTrendProps) {
  if (stats.byDate.length === 0) return null;

  return (
    <Card className="p-6" data-tourid="result-trend">
      <h2 className="mb-4 font-semibold text-lg">ແນວໂນ້ມຕາມວັນທີ</h2>
      <div className="space-y-2">
        {stats.byDate.slice(0, 10).map((day) => {
          return (
            <div key={day.date}>
              <div className="mb-1 flex items-center justify-between text-sm">
                <span>{formatDateLocal(day.date)}</span>
                <span className="text-muted-foreground">
                  ຜ່ານ: {day.pass} | ບໍ່ຜ່ານ: {day.fail} | ທັງໝົດ: {day.total}
                </span>
              </div>
              <div className="flex gap-1">
                <div
                  className="h-3 bg-green-500"
                  style={{
                    width: `${(day.pass / day.total) * 100}%`,
                  }}
                />
                <div
                  className="h-3 bg-red-500"
                  style={{
                    width: `${(day.fail / day.total) * 100}%`,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
